// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Zavc","newExpiryDate":"styles_newExpiryDate__1ieF_","footer":"styles_footer__3uTRu"};